import { createReducer, Action, on } from '@ngrx/store';
import { IrisResourceRoleI } from '@iris/common/models/IrisResourceRole';
import {
  LoadEnabledProjectResourceRoleComplete,
  LoadEnabledProjectResourceRoles,
  LoadAllProjectResourceRoleComplete,
  LoadAllProjectResourceRoles,
  LoadEnabledResourceRoles,
  LoadEnabledResourceRolesComplete,
  ResetResourceRolesState,
} from '../actions/resource-roles.actions';

export type State = Record<string, IrisResourceRoleI[]>;

const initialState: State = {
};

const ResourceRolesReducer = createReducer(
  initialState,
  on(LoadEnabledResourceRoles, (state, action) => ({
    ...state,
    [action.resourceType]: [],
  })),
  on(LoadEnabledResourceRolesComplete, (state, action) => ({
    ...state,
    [action.resourceType]: action.resourceRoles,
  })),
  on(LoadEnabledProjectResourceRoles, (state, action) => ({
    ...state,
    [action.projectId]: [],
  })),
  on(LoadEnabledProjectResourceRoleComplete, (state, action) => ({
    ...state,
    [action.projectId]: action.projectRoles,
  })),
  on(LoadAllProjectResourceRoles, (state, action) => ({
    ...state,
    [`${action.projectId}_all`]: [],
  })),
  on(LoadAllProjectResourceRoleComplete, (state, action) => ({
    ...state,
    [`${action.projectId}_all`]: action.projectRoles,
  })),
  on(ResetResourceRolesState, () => initialState),
);

export function reducer(state: State, action: Action) {
  return ResourceRolesReducer(state, action);
}

export const getEnabledResourceRoles = (state: State, resourceType: string): IrisResourceRoleI[] => {
  return state[resourceType];
};

export const getEnabledProjectResourceRoles = (state: State, projectId: number): IrisResourceRoleI[] => {
  return state[projectId];
};

export const getAllProjectResourceRoles = (state: State, projectId: number): IrisResourceRoleI[] => {
  return state[`${projectId}_all`];
};
